/**
 * Updates product URLs based on the current window origin.
 * @param {Array} products Array of product objects with `url` properties
 * @returns {Array} Updated array of products with modified `url` properties based on the current window origin
 */
export const updateProductPageUrls = (products) => {
  if (typeof window !== 'undefined' && window?.location?.origin) {
    const appOrigin = window.location.origin;

    // Only update URLs if we're on a known category-pages preview origin
    if (appOrigin.includes('category-pages.pre')) {
      return products.map((product) => {
        const replacements = {
          'https://category-pages.pre.dev': 'https://product-pages.pre.dev.cv1.garmin.com',
          'https://category-pages.pre.prod.cv1': 'https://product-pages.pre.prod.cv1.garmin.com',
          'https://category-pages.pre.prod.kc3': 'https://product-pages.pre.prod.kc3.garmin.com',
        };

        const match = Object.entries(replacements).find(([key]) => appOrigin.includes(key));

        if (match) {
          const [, replacement] = match;
          // eslint-disable-next-line no-param-reassign
          product.url = product.url.replace(
            /https?:\/\/(www|www\.dev)\.garmin\.com/gi,
            replacement,
          );
        }
        return product;
      });
    }
  }
  return products;
};

export default updateProductPageUrls;
